import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { Fragment } from "react";
import classnames from "classnames";
import { floatingLabelStyles } from "./floating-label-wrapper.scss";
const FloatingLabelWrapper = ({ children, label, htmlFor, isFocused, hasValue, variant, className })=>{
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: `jsx-${floatingLabelStyles.__hash}` + " " + (classnames("floating-label-wrapper", className, {
                    [`is-${variant}`]: variant,
                    "has-value": hasValue,
                    "is-focused": isFocused
                }) || ""),
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        htmlFor: htmlFor,
                        className: `jsx-${floatingLabelStyles.__hash}` + " " + "floating-label",
                        children: label
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: floatingLabelStyles.__hash,
                children: floatingLabelStyles
            })
        ]
    });
};
export default FloatingLabelWrapper;
